import { ClipboardList } from 'lucide-react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { ContractorAnswer } from '@/models/insuranceApplication'

/** What a contractor answered in the application chat, for staff to fill a carrier submission from. */
export function ContractorAnswersCard({ answers }: { answers: ContractorAnswer[] }) {
  return (
    <Card className="mb-6 gap-3">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <ClipboardList className="size-4" />
          Contractor application answers
        </CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid gap-3 text-sm">
          {answers.map((row) => (
            <div key={row.key} className="grid gap-0.5">
              <dt className="text-muted-foreground">{row.question}</dt>
              <dd className="text-foreground whitespace-pre-wrap">{row.answer}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  )
}
